import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { map, Observable } from "rxjs";
import { environment } from "../../../../environments/environment";
import { getContext } from "../../../core/interceptors/loader/loader.interceptor";
import { RadarResult } from "../../../core/types/radar-markets.types";

type Envelope<T> = { data: T };

/**
 * Il Radar Mercati.
 *
 * Due chiamate sole: una che avvia il calcolo e una che ne chiede lo stato.
 * Il calcolo dura decine di secondi, quindi `start` torna subito con la riga
 * in attesa e la pagina interroga `findMine` finché non è finito.
 */
@Injectable({ providedIn: "root" })
export class RadarMarketsService {
  private readonly baseUrl = `${environment.apiGatewayUrl}/radar-markets`;

  private readonly http = inject(HttpClient);

  /**
   * Avvia il calcolo, o restituisce quello già in corso.
   *
   * Senza rotella: la pagina mostra già la sua attesa, e una seconda sopra
   * non aggiunge niente.
   */
  start(): Observable<RadarResult> {
    return this.http
      .post<
        Envelope<RadarResult>
      >(this.baseUrl, {}, { context: getContext(false) })
      .pipe(map((response) => response.data));
  }

  /**
   * Tutti i Radar dell'azienda.
   *
   * Oggi ne esiste uno solo — il calcolo non si rifà — ma l'elenco è fatto
   * per contenerne più d'uno: è lì che si arriverà quando un'azienda potrà
   * avere più prodotti.
   */
  findAll(showLoader = true): Observable<RadarResult[]> {
    return this.http
      .get<Envelope<RadarResult[]>>(this.baseUrl, {
        context: getContext(showLoader)
      })
      .pipe(map((response) => response.data ?? []));
  }

  findMine(showLoader = false): Observable<RadarResult | null> {
    return this.http
      .get<Envelope<RadarResult | null>>(`${this.baseUrl}/me`, {
        context: getContext(showLoader)
      })
      .pipe(map((response) => response.data));
  }
}
